import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Avatar_09,
  Avatar_02,
  Avatar_03,
  Avatar_05,
  Avatar_08,
  Avatar_10,
  Avatar_15,
  Avatar_20,
  Avatar_24,
  Avatar_25,
} from "../../../Entryfile/imagepath";

import { Input, Table } from "antd";
import "antd/dist/antd.css";
import { itemRender, onShowSizeChange } from "../../paginationfunction";
import "../../antdstyle.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";

import { SearchOutlined } from "@ant-design/icons";
import { HrApi } from "../../../initialpage/hooks/HrApi";
import useAuth from "../../../initialpage/hooks/useAuth";
const Department = () => {
  const [data, setData] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadUpdate, setLoadUpdate] = useState(false);
  const [IndividualDepartment, setIndividualDepartment] = useState(false);
  const { searchFunction } = useAuth();
  // React Hook Form
  const {
    register: register,
    reset: reset,
    formState: { errors: errors },
    handleSubmit: handleSubmit,
  } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  // post Method
  const onSubmitPost = (data1) => {
    axios({
      method: "post",
      url: `${HrApi}/hr/setting/post/department`,
      data: {
        DEPARTEMENT: data1.departement,
      },
      headers: { Authorization: "Bearer ..." },
    }).then((res) => {
      if (res.data?.data.error == null) {
        setLoadUpdate(true);
        swal({
          title: "Thank you",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        reset();
        DepartmentGet();
        window.$("#add_department").modal("hide");
      }
    });
  };

  // PUT METHOD
  const [getId, setGetId] = useState(null);

  const onSubmitUpdate = (data1) => {
    if (data1.departement) {
      data1.departement = data1.departement;
    } else {
      data1.departement = IndividualDepartment.departement;
    }

    //

    // PUT METHOD
    axios({
      method: "put",

      headers: {
        department_id: getId,
      },
      url: `${HrApi}/hr/setting/put/department`,
      data: {
        department: data1.departement,
      },
    }).then((res) => {
      if (res.data.error == null) {
        setLoadUpdate(true);
        swal({
          title: "Thank you",
          text: "Successfully Updated",
          icon: "success",
          button: "Ok",
        });
        reset1();
        DepartmentGet();
        window.$("#edit_department").modal("hide");
      }
    });
  };

  const handleUpdate = (updateId) => {
    //
    let filterUniqueId = data?.filter((row) => row.departement_id == updateId);
    console.log("filterUniqueId", filterUniqueId[0]);
    setIndividualDepartment(filterUniqueId[0]);
    setGetId(updateId);
  };
  //

  // Delete API
  const deleteButtonHandler = (Id) => {
    //
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = `${HrApi}/hr/setting/delete/department`;
        fetch(url, {
          method: "DELETE",
          headers: {
            department_id: Id,
          },
        }).then((item) => {
          DepartmentGet();
        });
        swal("Poof! Your imaginary file has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  const [searchDepartment, setSearchDepartment] = useState("");
  // GET Department DATA
  useEffect(() => {
    DepartmentGet();
  }, [searchDepartment, loadUpdate]);

  const DepartmentGet = () => {
    setIsLoading(true);
    fetch(`${HrApi}/hr/setting/get/department`)
      .then((res) => {
        // You have to send it, as I have done below
        if (res.status >= 400) {
          throw new Error("Server responds with error!");
        }
        return res.json();
      })
      .then(
        (users) => {
          const getSignData = users.items;
          const searchData = searchFunction(
            getSignData,
            searchDepartment,
            "departement_id",
            "departement"
          );
          setData(searchData);

          setIsLoading(false);
          setLoadUpdate(false);
        },

        (err) => {
          const mute = err;
          setHasError(true);
          setIsLoading(true);
        }
      );
  };
  const columns = [
    {
      title: "DEPARTMENT ID",
      dataIndex: "departement_id",
    },
    {
      title: "DEPARTMENT",
      dataIndex: "departement",
    },

    {
      title: "Action",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-right">
          <a
            href="#"
            className="action-icon dropdown-toggle"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </a>
          <div className="dropdown-menu dropdown-menu-right">
            <a
              className="dropdown-item"
              href="#"
              data-toggle="modal"
              data-target="#edit_department"
              onClick={() => {
                handleUpdate(record.departement_id);
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </a>
            <a
              className="dropdown-item"
              href="#"
              onClick={() => {
                deleteButtonHandler(record.departement_id);
              }}
            >
              <i className="fa fa-trash-o m-r-5" /> Delete
            </a>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <Helmet>
          <title>Departments - HR</title>
          <meta name="description" content="Login page" />
        </Helmet>
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Departments</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/app/main/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Departments</li>
                </ul>
              </div>
              <div className="col-auto float-right ml-auto">
                <a
                  href="#"
                  className="btn buttonColor"
                  data-toggle="modal"
                  data-target="#add_department"
                >
                  <i className="fa fa-plus" /> Add new Departments
                </a>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row  mb-4 ps-2">
            <input
              onChange={(e) => {
                setSearchDepartment(e.target.value);
              }}
              className="form-control w-25 shadow py-4"
              type="text"
              placeholder="Search Here"
            />
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  pagination={{
                    total: data?.length,
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    showSizeChanger: true,
                    onShowSizeChange: onShowSizeChange,
                    itemRender: itemRender,
                  }}
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  bordered
                  dataSource={data}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
        {/* Add Department Modal */}

        <div
          id="add_department"
          className="modal custom-modal fade"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add new departments</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                </button>
              </div>
              <div className="modal-body text-start">
                <form onSubmit={handleSubmit(onSubmitPost)}>
                  <div className="row">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput14"
                        className="form-label fw-bold small"
                      >
                        Department title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput14"
                        placeholder="Enter Department title"
                        {...register("departement")}
                      />
                    </div>
                  </div>

                  <div className="submit-section">
                    <button
                      type="submit"
                      className="btn buttonColor px-5 py-2 rounded"
                    >
                      Add
                    </button>

                    <button
                      type="button"
                      className="btn buttonColor px-5 ms-1 py-2 rounded"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Department Modal */}

        <div
          id="edit_department"
          className="modal custom-modal fade"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Department</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                </button>
              </div>
              <div className="modal-body text-start">
                <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                  <div className="row">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput14"
                        className="form-label fw-bold small"
                      >
                        Department title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput14"
                        defaultValue={IndividualDepartment.departement}
                        {...register1("departement")}
                      />
                    </div>
                  </div>

                  <div className="submit-section">
                    <button
                      type="submit"
                      className="btn buttonColor px-5 py-2 rounded"
                    >
                      Update
                    </button>

                    <button
                      type="button"
                      className="btn buttonColor px-5 ms-1 py-2 rounded"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Department;
